import { render, staticRenderFns } from "./AssessmentParametersPane.vue?vue&type=template&id=42f63d53&"
import script from "./AssessmentParametersPane.vue?vue&type=script&lang=ts&"
export * from "./AssessmentParametersPane.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42f63d53')) {
      api.createRecord('42f63d53', component.options)
    } else {
      api.reload('42f63d53', component.options)
    }
    module.hot.accept("./AssessmentParametersPane.vue?vue&type=template&id=42f63d53&", function () {
      api.rerender('42f63d53', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "landing/src/molecules/organization/profile/AssessmentParametersPane.vue"
export default component.exports